export const BENCHMARK_RISK_METRIX_ERROR = 'keine Daten für die Benchmark verfügbar';
export const EMPTY_BENCHMARK_MESSAGE = 'Es wurde keine Benchmark zum Vergleich ausgewählt';